export const loadAgencies = bool => ({
    type: 'LOAD_AGENCIES',
    bool
})